/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Follow Up Absenteeism Adherence List View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './FollowUpAbsenteeismAdherenceListView';

export const mapStateToPropsFollowUpAbsenteeismAdherenceList = mapStateToProps;
export const mapDispatchToPropsFollowUpAbsenteeismAdherenceList =
  mapDispatchToProps;

export default connect(
  mapStateToPropsFollowUpAbsenteeismAdherenceList,
  mapDispatchToPropsFollowUpAbsenteeismAdherenceList
)(View);
